export default class oauthConfigProvider {
  constructor() {
    "ngInject";

    const domain = document.baseURI || window.location.origin + window.location.pathname

    // si aqui se pone una varaible a null
    // esta debera ser configurada por la aplicacion que use este modulo
    this.config = {
      CLIENT_ID: null,
      loginState: null,
      no_role_redirect: null,
      user_roles: null,
      user_redirects: null,
      login_callback_url:  domain+"#/oauth_callback?",
      logout_callback_url: domain,
      authentificationServer: "http://oauth.opileak.es",
      authentificationApi: "http://oauth-api.opileak.es/0",
    }
  }
  configure(options) {
    Object.assign(this.config, options)
  }
  $get() {
    const missingProps = []
    Object.keys(this.config).forEach(key => {
      const value = this.config[key];
      if(value === null) {
        missingProps.push(key);
      }
    })
    if(missingProps.length > 0) {
      throw new Error(`oauthConfigProvider no ha recibido la configuracion necesaria.
                       \nPor favor, configure las siguientes opciones usando
                       oauthConfigProvider.configure: \n ${missingProps.join(", ")}`)
    }
    return this.config
  }
}



// WEBPACK FOOTER //
// ./src/providers/oauthConfig.provider.js